import BaseRepository from './BaseRepository';

export default class RequestQuotesRepository extends BaseRepository
{
    getEndpoint()
    {
        return 'v1/request-hotels';
    }

    attachServices(requestHotelId, data)
    {
        return this.request('POST', `${this.getEndpoint()}/${requestHotelId}/attach-services`, data);
    }
}
